<template>
  <base-material-card :icon="resource.icon" :title="title">
    <va-list :sort-by="['timestamp']" :sort-desc="[true]" disable-export :filters="filters" :items-per-page="100">
      <va-data-table :fields="fields" disable-clone disable-edit disable-delete>
        <template v-slot:[`item.actions`]="{ item }">
          <test-gateway-button :item="item" />
        </template>
        <template v-slot:item.actions="{ item }">
          <va-action-button icon="mdi-attachment" label="Request" text @click="showAttachment(item, 'request')" :disabled="item.request == null"></va-action-button>
          <va-action-button icon="mdi-attachment" label="Response" text @click="showAttachment(item, 'response')" :disabled="item.response == null"></va-action-button>
          <va-action-button icon="mdi-attachment" label="Exception" text @click="showAttachment(item, 'exception')" :disabled="item.exception == null"></va-action-button>
        </template>
      </va-data-table>
    </va-list>
  </base-material-card>
</template>
<script>
import i18n from "@/i18n";

export default {
  props: ["resource", "title"],
  methods: {
    showAttachment(item, type) {
      window.open(`${process.env.VUE_APP_API_URL}/messages/${item.id}/${type}`, "_blank");
    },
  },
  data() {
    return {
      fields: [
        {
          label: i18n.t("integrations.fields.channel"),
          source: "channel",
          type: "reference",
          attributes: {
            reference: "channels",
            action: null
          },
          sortable: true
        },
        {
          label: "Sender",
          source: "sender",
          sortable: true
        },
        {
          label: "Recipient",
          source: "recipient",
          sortable: true
        },
        {
          label: "Timestamp",
          source: "timestamp",
          type: "date",
          sortable: true
        }
      ],
      filters: [
        {
          label: i18n.t("integrations.fields.channel"),
          source: "channel_data",
          type: "reference",
          attributes: {
            reference: "channels",
            action: null
          },
          sortable: true
        },
        {
          label: i18n.t("integrations.fields.channel"),
          source: "channel",
          type: "autocomplete",
          alwaysOn: true,
          resettable: true,
          attributes: {
            multiple: true,
            reference: "channels_globals_as_defaults",
            searchQuery: "q",
            sortBy: ["name"]
          }
        }
      ]
    };
  }
};
</script>
